import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ModalRef, ModalModule, InputV2Module, ButtonV2Module } from '@schenck/rotec-components';
import { DuplicateRotorTypeData } from 'src/utils/interfaces/rotor-type.interfaces';
import { Store } from '@ngrx/store';
import { RotorTypeSettingFormUpdate } from '../../../pages/rotor-type-details/store/rotor-type-details-store.actions';
import { RotorTypeDetailsStore } from '../../../pages/rotor-type-details/store/rotor-type-details-store.basic';
import { RotorTypeSettingsFormData } from '../../../utils/interfaces/rotor-type-forms-data.interfaces';
import { cloneDeep } from 'lodash';
import { TypeDataService } from 'src/services/type-data.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rtdm-duplicate-rotor-modal',
  templateUrl: './duplicate-rotor-modal.component.html',
  styleUrls: ['./duplicate-rotor-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalModule, TranslatePipe, TranslateDirective, InputV2Module, ButtonV2Module],
})
export class DuplicateRotorModalComponent implements OnInit {
  private readonly rotorTypeDetailsStore = inject<Store<RotorTypeDetailsStore>>(Store);
  private readonly typeDataService = inject(TypeDataService);
  public modalRef = inject<ModalRef<DuplicateRotorTypeData>>(ModalRef);

  /**
   * The width of the modal.
   */
  public width = '732px';
  /**
   * The height of the modal.
   */
  public height = '460px';
  /**
   * The title of the modal header
   */
  public title: string;
  /**
   * Title for duplicated rotor
   * */
  public duplicatedTitle: string;

  public uniqueNameError = false;

  private rotorTypeSettings: RotorTypeSettingsFormData;

  public ngOnInit(): void {
    this.title = this.modalRef.data.name;
    this.rotorTypeSettings = cloneDeep(this.modalRef.data.rotorTypeSettings);
  }

  public close(): void {
    this.modalRef.emitAndClose('close');
  }

  public apply(): void {
    this.duplicateRotorRequest();
    this.modalRef.emitAndClose('save');
  }

  public getDuplicatedTitle(title: string): string {
    if (!this.duplicatedTitle) {
      this.duplicatedTitle = `${title}(1)`;
      if (title.indexOf('(') !== -1 && title.indexOf(')') !== -1) {
        const duplicatedNumber = title.substring(title.indexOf('(') + 1, title.indexOf(')')).trim();
        const nameWithoutDuplicatedNumber = title.substring(0, title.indexOf('('));

        this.duplicatedTitle = `${nameWithoutDuplicatedNumber}(${
          !isNaN(+duplicatedNumber) ? +duplicatedNumber + 1 : duplicatedNumber + 1
        })`;
      }
    }
    return this.duplicatedTitle;
  }

  public setDuplicatedValue(event: string) {
    this.duplicatedTitle = event;
    this.uniqueNameError = this.typeDataService.state.some(({ name }) => name === event);
  }

  private duplicateRotorRequest(): void {
    this.rotorTypeSettings.rotorTypeName = this.duplicatedTitle;
    this.rotorTypeDetailsStore.dispatch(new RotorTypeSettingFormUpdate(this.rotorTypeSettings));
  }
}
